import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from '../layout';
import HeaderDetailPageContainer from '../../containers/header-detail-page-container';
import LivePreviewSlider from '../live-preview-slider';
import { DESKTOP } from '../../modules/live-preview/constants';
import getPreviewModeForDevice from '../../modules/live-preview/helpers/get-preview-mode-for-device';

export const LivePreviewContext = React.createContext({
  mode: DESKTOP,
  toggleMode: Function.prototype,
});

function TemplateDetails({ name, livePreviewUrl }) {
  const defaultPreviewMode = getPreviewModeForDevice();
  const [previewMode, setPreviewMode] = useState(defaultPreviewMode);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <LivePreviewContext.Provider
      value={{
        mode: previewMode,
        toggleMode: setPreviewMode,
      }}
    >
      <Layout Header={HeaderDetailPageContainer}>
        <Fragment>
          <LivePreviewSlider toMode={previewMode} name={name} url={livePreviewUrl} />
        </Fragment>
      </Layout>
    </LivePreviewContext.Provider>
  );
}

TemplateDetails.propTypes = {
  name: PropTypes.string.isRequired,
  livePreviewUrl: PropTypes.string.isRequired,
};

export default TemplateDetails;
